import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-logistics-vehicle-link',
  templateUrl: './logistics-vehicle-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogisticsVehicleLinkComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Input() name: string;
  @Input() showTooltip?: boolean;

  constructor() {

  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

}
